import React from 'react'
import styles from './index.module.css'
import { Link } from 'react-router-dom'

const Index = () => {

  return (
    <>
    <nav className={styles.wrapper}>
            <Link to={'/'}>ВЕТЕРАН.АИ</Link>
        <div className={styles.links}>
            <Link to={'/about'}>О нас</Link>
            <Link to={'/tests'}>Тесты</Link>
        </div>
        
        <Link to={'/auth'}>Войти</Link>
    </nav>
    </>
  )
}

export default Index